import { useState } from "react";

export const PartnerPage = () => {

  return (
    <>
      <div id="partner" className="container pt-5">
        <div className="text-center my-5">
          <div className="fw-bolder txt-26">戰略夥伴</div>
          <div style={{ color: '#0866a9', fontSize: '1.2rem' }}>Partner</div>
        </div>
        <div className="d-flex flex-wrap my-5">
          <a href="/web/partner/businesstoday/redirect" target="_blank" rel="noreferrer" className="col-6 col-md-4 col-lg-4 tsite">
            <img src={require('../assets/img/nft/today.png')} alt="" className="mw-100 mb-3" />
            <div className="fw-bolder h5 mb-0">今周學堂</div>
          </a>
          <a href="https://9gscdna.com" target="_blank" rel="noreferrer" className="col-6 col-md-4 col-lg-4 tsite">
            <img src={require('../assets/img/home/9-icon.png')} alt="" className="mw-100 mb-3" style={{ maxHeight: '100px' }} />
            <div className="fw-bolder h5 mb-0">九宮靈數</div>
          </a>

          <a href="https://nft.star-river.pro/" target="_blank" className="col-6 col-md-4 col-lg-4 tsite" rel="noreferrer">
            <img src={require('../assets/img/star/sr-icon.png')} alt="" className="mw-100 mb-3" style={{ maxHeight: '100px' }} />
            <div className="fw-bolder h5 mb-0">StarRiver</div>
          </a>
        </div>
      </div>


      <div className="p-5"></div>
      <div className="p-5"></div>
    </>
  );
}